import { useRef, useState } from 'react';
import media from '~/assets/icons/media.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Divider } from '~/components/ui/Divider';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { TextInput } from '~/components/ui/TextInput';
import { rage } from '~/rage';
import {
	StyledButtonsGrid,
	StyledContainer,
	StyledModalHead,
	StyledModalWrapper,
} from './ModalAddPhoto.styled';

const photoHostingLink = 'https://imgur.com/';

const ModalAddPhoto: React.FC<{
	photos: string[];
	activePhotoIndex: number;
	setPhotos: (photos: string[]) => void;
	onClose: () => void;
}> = ({ photos, activePhotoIndex, setPhotos, onClose }) => {
	const [link, setLink] = useState<string>(photos[activePhotoIndex]);
	const [isCopied, setIsCopied] = useState<boolean>(false);
	const fileInputRef = useRef<HTMLInputElement | null>(null);
	// TODO: add sdk
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [selectedFileName, setSelectedFileName] = useState<string>('');
	// TODO: add sdk
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [selectedFile, setSelectedFile] = useState<File | null>(null);

	const handleFileChange = (event: any) => {
		const file = event.target.files?.[0];

		if (!file) return;

		setSelectedFile(file);
		setSelectedFileName(file.name);

		const reader = new FileReader();

		reader.onload = () => {
			if (typeof reader.result === 'string') {
				setLink(reader.result);
			}
		};

		reader.readAsDataURL(file);
	};

	return (
		<StyledModalWrapper>
			<StyledContainer>
				<StyledModalHead>
					<SectionHeading
						text="Добавить фото"
						icon={media}
						gap={20}
						iconSize={20}
						fontSize={18}
						textStyle={{ fontWeight: 700 }}
						textOpacity={1}
						iconOpacity={1}
					/>
					<CloseButton
						height={ButtonHeight.Height20}
						color={ButtonColors.Default}
						borderRadius={ButtonBorderRadius.Radius5}
						iconSize={10}
						onClick={onClose}
					/>
				</StyledModalHead>
				<Divider $direction="H" style={{ margin: '30px 0', opacity: 0.1 }} />
				<TextInput
					placeholder="Вставьте ссылку на фото"
					height={50}
					fontSize={16}
					padding="0 20px"
					value={link}
					onChange={(e) => {
						setLink(e.target.value);
					}}
				/>
				<Button
					color={isCopied ? ButtonColors.Buy : ButtonColors.Default}
					height={ButtonHeight.Height50}
					style={{ marginTop: 30 }}
					onClick={() => {
						if (isCopied) return;
						rage.input.copyToClipboard(photoHostingLink);
						setIsCopied(true);
						setTimeout(() => {
							setIsCopied(false);
						}, 3000);
					}}
				>
					<Text>
						{isCopied
							? 'Ссылка скопирована'
							: 'Скопировать ссылку на фото-хостинг'}
					</Text>
				</Button>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height50}
					style={{ marginTop: 20 }}
					onClick={() => {
						fileInputRef.current?.click();
					}}
				>
					<Text>Выбрать файл</Text>
				</Button>
				<input
					ref={fileInputRef}
					type="file"
					accept="image/*"
					style={{ display: 'none' }}
					onChange={handleFileChange}
				/>
				<StyledButtonsGrid>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height50}
						onClick={onClose}
					>
						<Text>Отменить</Text>
					</Button>
					<Button
						color={ButtonColors.Select2}
						height={ButtonHeight.Height50}
						onClick={() => {
							setPhotos(
								photos.map((photo, index) =>
									index === activePhotoIndex ? link : photo,
								),
							);
							onClose();
						}}
					>
						<Text>Добавить</Text>
					</Button>
				</StyledButtonsGrid>
			</StyledContainer>
		</StyledModalWrapper>
	);
};

export { ModalAddPhoto };
